<div class="stat-card" [ngClass]="'stat-card--' + accent">
  @if (icon) {
    <span class="stat-card__icon">
      <i class="fa" [ngClass]="icon"></i>
    </span>
  }
  <div class="stat-card__body">
    <span class="stat-card__title">{{ title }}</span>
    <span class="stat-card__count">{{ count || 0 }}</span>
    <span class="stat-card__amount">
      <span class="stat-card__amount-label">Amount</span>
      <span class="stat-card__amount-value">NGN {{ amount || 0 | number }}</span>
    </span>
  </div>
</div>
